import { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const ContactMe = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  var templateParams = {
    name,
    email,
    subject,
    message,
  };

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_3w40sp1",
        "template_pb2bk4d",
        templateParams,
        "McdrEZpkh7wzs74hp"
      )
      .then(
        (result) => {
          toast.success("Email Sent Successfully");
          setName("");
          setEmail("");
          setSubject("");
          setMessage("");
        },
        (error) => {
          toast.error("Something went wrong");
        }
      );
  };

  return (
    <div className="h-screen flex relative flex-col text-center md:text-left md:flex-row  max-w-7xl px-10 justify-evenly mx-auto items-center">
      <h3 className="absolute top-24 uppercase tracking-[20px] text-gray-500 text-2xl cursor-default">
        Contact
      </h3>

      <div className="flex flex-col space-y-10 mt-28 ">
        <h4 className="text-2xl md:text-4xl font-semibold text-center cursor-default">
          I got just what you need.{" "}
          <span className="text-[#F7AB0A] cursor-default">Lets Talk</span>
        </h4>

        <div className="space-y-3 ">
          <div className="flex items-center space-x-5 justify-center">
            <img
              src="https://img.icons8.com/material-rounded/24/F7AB0A/phone--v1.png"
              alt="phone--v1"
              className="h-7 w-7 animate-pulse"
            />
            <p className="text-2xl">+917357412277</p>
          </div>

          <div className="flex items-center space-x-5 justify-center">
            <img
              src="https://img.icons8.com/material-rounded/24/F7AB0A/address.png"
              alt="phone--v1"
              className="h-7 w-7 animate-pulse"
            />
            <p className="text-2xl">Mumbai, India</p>
          </div>

          <div className="flex items-center space-x-5 justify-center">
            <img
              src="https://img.icons8.com/ios-glyphs/30/F7AB0A/new-post.png"
              alt="phone--v1"
              className="h-7 w-7 animate-pulse"
            />
            <p className="text-2xl">bhupeshvyas202@gmail.com</p>
          </div>
        </div>

        <form
          onSubmit={sendEmail}
          className="flex flex-col  space-y-2 w-fit  mx-auto "
        >
          <motion.div
            initial={{
              x: -100,
            }}
            whileInView={{
              x: 0,
            }}
            transition={{
              duration: 1,
            }}
            className="flex space-x-1 sm:space-x-2 sm:justify-between  "
          >
            <input
              placeholder="Name"
              className="contactInput"
              type="text"
              style={{ width: "50%" }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              placeholder="Email"
              className="contactInput "
              type="email"
              style={{ width: "50%" }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </motion.div>
          <motion.input
            initial={{
              x: 100,
              opacity: 0,
            }}
            whileInView={{
              x: 0,
              opacity: 1,
            }}
            transition={{
              duration: 1,
            }}
            placeholder="Subject"
            className="contactInput"
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
          <motion.textarea
            initial={{
              x: -100,
              opacity: 0,
            }}
            whileInView={{
              x: 0,
              opacity: 1,
            }}
            transition={{
              duration: 1,
            }}
            placeholder="Message"
            className="contactInput"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <motion.button
            initial={{
              x: 100,
              opacity: 0,
            }}
            whileInView={{
              x: 0,
              opacity: 1,
            }}
            transition={{
              duration: 1,
            }}
            type="submit"
            className="bg-[#F7AB0A] py-5 px-10 rounded-md text-black font-bold transition duration-200  ease-in-out hover:drop-shadow-[0_0px_4px_#F7AB0A]"
          >
            Submit
          </motion.button>
        </form>
      </div>
    </div>
  );
};

export default ContactMe;
